import { Col, Container } from '@microfrontends/react-components'
import MostUsageCV from '../../../components/MostUsageCV'
import { WowCvWrap } from '../../../components/NumerologyV2/index.css'

export default function MostCV() {
	return (
		<Container>
			<WowCvWrap>
				<Col>
					<MostUsageCV />
				</Col>
			</WowCvWrap>
		</Container>
	)
}
